import cx from "classnames";
import { useTranslation } from "next-i18next";

import { Button, Message } from "../elements";
import { Accordion } from "../elements/Accordion";
import { AccordionList } from "../elements/AccordionList";
import { Icons } from "../elements/Icon/types";
import styles from "./styles.module.css";

export const ProductAccordion = ({
  productDetails: {
    dispensers,
    description,
    instructions,
    ingredients,
    swan_license_number,
  },
  onClick,
}) => {
  const { t } = useTranslation("product");
  const dispenser = dispensers?.[0];
  const [filename] = dispenser.iconSrc.match(/[^\/]+(?=\.)/);
  const icon = `dispenser_${filename.replaceAll("-", "_")}` as Icons;

  return (
    <AccordionList className={styles.infoBlocks}>
      <Accordion
        title={t("product_description")}
        version="list"
        startOpen={true}
      >
        <p className={cx(styles.additionalInfo, styles.productDescription)}>
          {description}
        </p>
      </Accordion>
      <Accordion title={t("how_to_use")} version="list">
        {dispenser && (
          <Message type="warning" icon={icon} className={styles.message}>
            {t("how_to_use_dispenser", {
              dispenserTitle: dispenser.title,
            })}{" "}
            <Button theme="underline" onClick={onClick}>
              {t("read_more")}
            </Button>
          </Message>
        )}
        <p className={styles.additionalInfo}>{instructions}</p>
      </Accordion>
      <Accordion title={t("ingredients")} version="list">
        <p className={styles.additionalInfo}>{ingredients}</p>
      </Accordion>
      {swan_license_number ? (
        <Accordion title={t("swan_logo.title")} version="list">
          <p className={cx(styles.additionalInfo, styles.additionalInfoLogo)}>
            {t("swan_logo.sub_title")}
          </p>
          <p className={styles.additionalInfo}>{t("swan_logo.description")}</p>
        </Accordion>
      ) : null}
    </AccordionList>
  );
};
